import { ReferralDTO } from "./referralDTO";


export class ReferralRow {


    constructor(private _id: string | undefined, private _referralCode: string | undefined, private _type: ReferralDTO.TypeEnum, private _status: ReferralDTO.StatusEnum,
        private _organizationId: string | undefined, private _legacyOrganizationId: string | undefined,
        private _amount?: number | undefined, private _percent?: boolean) {

    }

    public get id() {
        return this._id;
    }
    public get referralCode() {
        return this._referralCode;
    }
    public get type() {
        return this._type;
    }
    public get status() {
        return this._status;
    }
    public get organizationId() {
        return this._organizationId;
    }
    public get legacyOrganizationId() {
        return this._legacyOrganizationId;
    }
    public get amount() {
        return this._amount;
    }
    public get percent() {
        return this._percent;
    }

    public static mapRowsFromReferralDTO(referrals: ReferralDTO[] = []): ReferralRow[] {
        let rows: ReferralRow[] = [];
        if (referrals) {
            referrals.forEach(r => {
                if (r.payees && r.payees.length > 0) {
                    rows.push(new ReferralRow(r.id, r.referralCode, r.type ? r.type : "TRAVEL", r.status ? r.status : "ACTIVE", r.payees[0].organizationId, r.payees[0].legacyOrganizationId,
                        r.payees[0].commission?.amount,
                        r.payees[0].commission?.percentage)
                    )
                }
            })
            return rows;
        }
        return [];
    }

}


